export const storeTimelineValues = (state, timelineValues, totalTimeline) => {
  return {
    ...state,
    timeline: [...state.timeline, ...timelineValues],
    total: totalTimeline,
  };
};

export const getAvatars = (state, avatars) => {
  return {
    ...state,
    avatars: avatars
  }
}

export const getSounds = (state, sounds) => {
  return {
    ...state,
    sounds: sounds
  }
}

export const setLoader = (state, loaderValue) => {
  return {
    ...state,
    isLoading: loaderValue,
  };
};

export const updateSinglePost = (state, post) => {
  const postCopy = [...state.post];

  postCopy[
    postCopy.findIndex((tPost) => {
      return tPost.id === post.id;
    })
  ] = {
    ...post,
  };

  return {
    ...state,
    post: postCopy,
  };
};

export const updatePost = (state, post) => {
  const timelineCopy = [...state.timeline];

  timelineCopy[
    timelineCopy.findIndex((tPost) => {
      return tPost.id === post.id;
    })
  ] = {
    ...post,
  };

  return {
    ...state,
    timeline: timelineCopy,
  };
};

export const createPost = (state, post) => {
  var newTimeline = Array.from(new Set([post, ...state.timeline]));

  return {
    ...state,
    total: state.total + 1,
    timeline: newTimeline,
  };
};

export const createPostEnd = (state, post) => {
  var newTimeline = Array.from(new Set([...state.timeline, post]));

  return {
    ...state,
    total: state.total + 1,
    timeline: newTimeline,
  };
};

export const deletePost = (state, post) => {
  var newTimeline = state.timeline.filter(
    (timeline) => timeline.id !== post.id
  );

  return {
    ...state,
    total: state.total - 1,
    timeline: newTimeline,
  };
};

export const publishPost = (state, post) => {
  const timelineCopy = [...state.timeline];
  const postCopy = [...state.post];

  var newTimeline = timelineCopy.findIndex((tPost) => {
    return tPost.id === post.post_id;
  });

  if (newTimeline !== -1 && state.post.length === 0) {
    timelineCopy[newTimeline].data = post;

    return {
      ...state,
      timeline: timelineCopy,
    };
  }

  if (newTimeline !== -1 && state.post.length === 1) {
    timelineCopy[newTimeline].data = post;

    postCopy[
      postCopy.findIndex((tPost) => {
        return tPost.id === post.post_id;
      })
    ].data = post;

    return {
      ...state,
      timeline: timelineCopy,
      post: postCopy,
    };
  }

  postCopy[
    postCopy.findIndex((tPost) => {
      return tPost.id === post.post_id;
    })
  ].data = post;

  return {
    ...state,
    post: postCopy,
  };
};

export const storeSinglePost = (state, myPost) => {
  return {
    ...state,
    post: [myPost],
  };
};

export const clearSinglePost = (state) => {
  return {
    ...state,
    post: [],
  };
};

export const pageIncreament = (state) => {
  var newPage = state.page + 1;

  return {
    ...state,
    page: newPage,
  };
};

export const getTimelineVideos = (state, videos, category) => {
  if (category === "intro")
    return {
      ...state,
      introVideos: videos,
    };
  if (category === "outro")
    return {
      ...state,
      outroVideos: videos,
    };
};

export const getTimelineMessageTemplates = (state, messages) => {
  return {
    ...state,
    messageTemplates: messages,
  };
};

export const getLatestRecognition = (state, latestRecognition) => {
  return {
    ...state,
    latestRecognition: latestRecognition,
  };
};

export const clearAll = (state) => {
  return {
    avatars: state.avatars,
    sounds: state.sounds,
    timeline: [],
    introVideos: [],
    outroVideos: [],
    messageTemplates: [],
    latestRecognition: null,
    post: [],
    total: "",
    isLoading: true,
    page: 1,
  };
};
